import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import BodyText from 'components/widget/BodyText';
import { addDataLayer } from 'lib/GoogleTagManager';

const Wrapper = styled(Link)`
  color: inherit;
  text-decoration: inherit;
  .mainTitleWrapper {
    display: flex;
    align-items: center;
    justify-content:space-between;
    margin: ${({ theme }) => theme.spacing * 1.5}px 0;

    .mainTitle {
      margin: 0;
    }
  }

  .chevron {
    font-size: 1.4rem;
  }

  &.small {
    .mainTitle{
      font-size: 1.1rem;
    }
    .subTitle {
      font-size: 1rem;
    }
  }
`;

const PaneCTA = ({
  className, linkProps, heading, mainTitle, subTitle, small, children, dataLayer,
}) => {
  const classes = ['PaneCTA', className, small && 'small'];

  const handleClick = () => {
    if (dataLayer) {
      addDataLayer(dataLayer);
    }
  };

  return (
    <Wrapper
      className={classes.filter((c) => !!c).join(' ')}
      onClick={handleClick}
      {...linkProps}
    >
      <div className="PaneContentWrapper">
        <h4>{heading}</h4>
        <div className="mainTitleWrapper">
          {mainTitle && <h2 className="mainTitle">{mainTitle}</h2>}
          {children}
          <FontAwesomeIcon className="chevron" icon={faChevronRight} />
        </div>
        <BodyText className="subTitle">{subTitle}</BodyText>
      </div>
    </Wrapper>
  );
};

PaneCTA.propTypes = {
  className: PropTypes.string,
  small: PropTypes.bool,
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  mainTitle: PropTypes.string,
  subTitle: PropTypes.string,
  dataLayer: PropTypes.shape({
    action: PropTypes.string,
    label: PropTypes.string,
  }),
  linkProps: PropTypes.shape({}),
  children: PropTypes.node,
};

PaneCTA.defaultProps = {
  className: null,
  linkProps: null,
  mainTitle: null,
  subTitle: null,
  dataLayer: null,
  small: false,
  children: null,
};

export default PaneCTA;
